module.exports = __webpack_public_path__ + "img/bioenergy.239d4280.jpg";